import React from 'react';
import CompareTooltip from './CompareTooltip';

function AGGridCountOfResponsesCellRenderer({data, value}) {
	return (
		<CompareTooltip
			data={data}
			value={value}
			renderer={
				<section className="trigger-count">{`${data.countOfResponses} (${data.percentageOfResponses}%)`}</section>
			}
		/>
	);
}

export default AGGridCountOfResponsesCellRenderer;
